/**
 * Traverses the DAG breadth-first starting at the target CID and yields all
 * encountered blocks.
 *
 * Blocks linked to from the target block are traversed using codecs defined in
 * the helia config.
 */
export class SubgraphExporter {
    async *export(_cid, block) {
        for await (const [, linkedCid] of block.links()) {
            yield linkedCid;
        }
    }
}
//# sourceMappingURL=subgraph-exporter.js.map